import React, { ReactNode } from "react";

interface PanelProps {
    headerPanel?: ReactNode;
    children: ReactNode;
    footerPanel?: ReactNode;
}

export const Panel: React.FC<PanelProps> = (props) => {
    return (
        <div>
            {props.headerPanel && props.headerPanel}
            <div
                className={`${
                    props.footerPanel ? "body-panel-com-footer" : "mb-3"
                }`}
            >
                {props.children}
            </div>
            {props.footerPanel && props.footerPanel}
        </div>
    );
};
